import { RegionShared } from "@1games-ru/region-shared";
import clsx from "clsx";
import { VolumeIcon } from "@/shared/icons";

type Props = {
  className?: string;
  speakers: (typeof RegionShared.Cef.Requests.SetHudStateRequest)["speakers"];
};

export default function HudSpeakerList({ className, speakers }: Props) {
  return (
    <div className={clsx("flex flex-col gap-1.5", className)}>
      {speakers.map((item) => (
        <div
          key={item.id}
          className={clsx(
            "h-[2.25rem] flex items-center gap-2 px-3 py-2 font-medium text-white",
            "rounded-[0.5rem] bg-dark-900/60",
            item.isSpeaking ? "" : "opacity-50",
          )}
        >
          <VolumeIcon size={16} className="text-white shrink-0" />
          <div className="text-16 font-bold grow overflow-hidden text-nowrap [mask-image:linear-gradient(90deg,black,rgba(0,0,0,.9),transparent)]">
            {item.name}
          </div>
          <div className="text-11 font-bold px-1 py-0.5 bg-white/10 rounded-[0.25rem] shrink-0">{`ID: ${item.id}`}</div>
        </div>
      ))}
    </div>
  );
}
